/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment200,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParamsSchema =
  z
    .object({
      invoiceBody: z.optional(z.string()),
      invoiceEmail: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse>;
